import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToggleButton from 'react-toggle-button';
import * as actions from '../../actions/actions.jsx';
import s from '../../services/allservices.jsx';
import LoaderSmall from "../loader/loader.jsx";
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';




const Heart = () => (
  <div
    style={{
      color: '#fff',
      fontSize: '1.2em',
      margin: 'auto',

    }}
  >
    <i className="fa fa-lock " aria-hidden="true"></i>
  </div>
)
const Inactive = () => (
  <div
    style={{
      color: '#fff',
      fontSize: '1.2em',
      margin: 'auto',

    }}
  >
    <i className="fa fa-unlock-alt" aria-hidden="true"></i>
  </div>
)

const mapStateToProps = state =>
({
  publicKey: state.publicKey.publicKey,
  alertState: state.getAlertReducer.alertState,
  cardState: state.getCardReducer.cardState,
  cardPreferanceState: state.getCardPreferanceReducer.cardPreferanceState,

})
const mapDispatchToProps = dispatch =>
({
  fetchCardPreference(cardDetailsId) {
    dispatch(
      actions.getCardPreferanceAction(cardDetailsId)
    )
  },
  fetchCard(state) {
    dispatch(
      actions.getCardAction(state)
    )
  },
})

class CardPreferance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardDetailsId: 1,
      thresholdAmount: '',
      thresholdType: "G",
      alertEmailId: '',
      value: '',
      value1: '',
      serv: '',
      selectedCard: [],
      loader: false,
      correctEmail: true,
      correctamount: true,
    }


  }
  handleBasic = (astate) => {
    let detail = document.getElementById(astate.alertId + "1")
    detail.style.display = "none"

    let edit = document.getElementById(astate.alertId + "2")
    edit.style.display = "block"
    document.getElementById(astate.alertId + "cancel").style.display = "block"
    document.getElementById(astate.alertId + "edit").style.display = "none"
    this.setState({
      active: astate.active,
      alertEmailId: astate.alertEmailId,
      alertId: astate.alertId,
      alertName: astate.alertName,
      alertType: astate.alertType,
      alertValuesSet: astate.alertValuesSet,
      cardDetailsId: astate.cardDetailsId,
      contactNumber: astate.contactNumber,
      cutOverTime: astate.cutOverTime,
      merchantCategoryCodes: astate.merchantCategoryCodes,
      thresholdAmount: astate.thresholdAmount,
      thresholdType: astate.thresholdType,
      timezone: astate.timezone,
      useContactNumber: astate.useContactNumber,
      useMobilePush: astate.useMobilePush
    })
  }

  handleCancel = (alertid) => {

    let edit = document.getElementById(alertid + "2")
    edit.style.display = "none"

    let detail = document.getElementById(alertid + "1")
    detail.style.display = "block"

    document.getElementById(alertid + "cancel").style.display = "none"
    document.getElementById(alertid + "edit").style.display = "block"
  }

  handleChange = (event, index, value) => this.setState({ thresholdType: value }, () => { });
  onchangeEmail = (e, value) => {

    if (e.target.name === "alertEmailId" && value.length !== 0) {
      var eventVal = e.target.value
      this.setState({
        eventId: e.target.id
      }, () => {
        // eslint-disable-next-line
        if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(eventVal)) {
          this.setState({
            correctEmail: true,
            alertEmailId: value,

          })
        } else {
          this.setState({
            correctEmail: false,

          })
        }
      })

    }
  }

  onChangeAmount = (e, value) => {
    if (e.target.name === "thresholdAmount" && value.length !== 0) {
      var eventVal2 = e.target.value
      this.setState({
        eventId2: e.target.id
      }, () => {
        if (/^(\d+)?([.]?\d{0,2})?$/.test(eventVal2)) {
          this.setState({
            correctamount: true,
            thresholdAmount: value,

          })
        }
        else {
          this.setState({
            correctamount: false,

          })
        }
      })


    }
    // else {
    //     this.setState({
    //         correctamount: false,

    //     })
    // }

  }

  componentDidMount() {
    this.setState({
      loader: false,
      cardDetailsId: this.props.cardState.body[0].cardDetailsId,
      atmAccess: this.props.cardState.body[0].atmAccess,
      tapAndPay: this.props.cardState.body[0].tapAndPay,
    })

    this.props.fetchCardPreference(this.props.cardState.body[0].cardDetailsId)

    // setTimeout(function () {
    //     if (publicKey.status === 200) {
    //         const public_Key = publicKey.body.publickey;
    //         let encrypt = new JSEncrypt();
    //         encrypt.setPublicKey(public_Key);


    //         const state = {
    //             applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
    //             accountId: encrypt.encrypt(localStorage.getItem("accountId"))
    //         }
    //         _this.props.fetchCard(state)

    //     }
    // }, 500);
    // alertState.body.map((value,i)=>{
    //     document.getElementById(alertState.body[i].alertId+"2").style.display="none"
    // })
    //if (this.props.cardPreferanceState.status === 401) {
    //localStorage.clear();
    //this.props.history.push('/sessionout')
    //}
  }



  handleToggle = (altstate) => {

    let _this = this

    if (altstate.pos === false) {

      let state = {
        pos: true,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }


      this.setState({
        loader: true
      })
      // this.setState({
      //     cardBalanceLoader: true
      // })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdatePos, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)

            this.setState({
              loader: false
            })

          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });
            this.setState({
              loader: false
            })

          }
        })

    }
    else {
      let state = {
        pos: false,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }
      this.setState({
        loader: true
      })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdatePos, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)

            this.setState({
              loader: false
            })
          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });


          }
        })


    }
  }
  handleToggleEcom = (altstate) => {

    let _this = this

    if (altstate.ecom === false) {

      let state = {
        ecom: true,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }


      this.setState({
        loader: true
      })
      // this.setState({
      //     cardBalanceLoader: true
      // })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
  
      fetch(plink + s.UpdateEcom, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)


            this.setState({
              loader: false
            })

          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });
            this.setState({
              loader: false
            })

          }
        })

    }
    else {
      let state = {
        ecom: false,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }
      this.setState({
        loader: true
      })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdateEcom, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)



            this.setState({
              loader: false
            })
          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });


          }
        })


    }
  }
  handleToggleOverseas = (altstate) => {

    let _this = this

    if (altstate.international === false) {

      let state = {
        international: true,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }


      this.setState({
        loader: true
      })
      // this.setState({
      //     cardBalanceLoader: true
      // })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdateInternational, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)



            this.setState({
              loader: false
            })

          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });
            this.setState({
              loader: false
            })

          }
        })

    }
    else {
      let state = {
        international: false,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }
      this.setState({
        loader: true
      })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdateInternational, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)



            this.setState({
              loader: false
            })
          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });


          }
        })


    }
  }
  handleToggleATM = (altstate) => {

    let _this = this

    if (altstate.atm === false) {

      let state = {
        atm: true,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }


      this.setState({
        loader: true
      })
      // this.setState({
      //     cardBalanceLoader: true
      // })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdateATM, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)



            this.setState({
              loader: false
            })

          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });
            this.setState({
              loader: false
            })

          }
        })

    }
    else {
      let state = {
        atm: false,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }
      this.setState({
        loader: true
      })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdateATM, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)


            this.setState({
              loader: false
            })
          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });


          }
        })


    }
  }
  handleToggleTap = (altstate) => {

    let _this = this

    if (altstate.contactless === false) {

      let state = {
        contactless: true,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }


      this.setState({
        loader: true
      })
      // this.setState({
      //     cardBalanceLoader: true
      // })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdateContactLess, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)
            this.setState({
              loader: false
            })


          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });
            this.setState({
              loader: false
            })

          }
        })

    }
    else {
      let state = {
        contactless: false,
        cardDetailsId: this.state.cardDetailsId,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
      }
      this.setState({
        loader: true
      })

      let token = "Token " + localStorage.getItem('token')
      let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
      let traceId = getClientId();
      fetch(plink + s.UpdateContactLess, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': token,
          'X-Trace-Id': traceId,
          'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            _this.props.fetchCardPreference(this.state.cardDetailsId);
            setTimeout(function () {
              toast.success(response.headers.get('message'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
              });
            }, 2000)
            this.setState({
              loader: false
            })


          } else {

            toast.error(response.headers.get('message'), {
              position: "top-right",
              draggablePercent: 60,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });


          }
        })


    }
  }
  handleSelect1 = (event, index, value) => {

    const { cardState } = this.props
    for (let i = 0; i < cardState.body.length; i++) {
      if (cardState.body[i].cardDetailsId === value) {
        this.setState({
          cardInUse: cardState.body[i],
          atmAccess: cardState.body[i].atmAccess,
          tapAndPay: cardState.body[i].tapAndPay
        })
      }
    }

    let _this = this
    const { filteredCards } = this.state
    this.setState({
      cardDetailsId: value,

    }, () => {

      for (let i = 0; i < filteredCards.length; i++) {
        // if (this.state.cardDetailsId === filteredCards[i].cardDetailsId) {

        this.setState({

          selectedCard: filteredCards[i]
        }, () => {


          _this.setState({
            loader: true
          })
          // setTimeout(function () {
          _this.props.fetchCardPreference(this.state.cardDetailsId)
          // }, 500)

        })
        // }
      }
    });

  }
  componentWillReceiveProps(nextProps) {
    try {
      if (nextProps.cardState && nextProps.cardState.length !== 0) {
        var filteredR = nextProps.cardState.body.filter((val) => {
          return (val.cardType)
        })
        // var filteredG = nextProps.cardState.body.filter((val) => {
        //     return (val.cardType === "G")
        // })

        var filteredCards = filteredR
        this.setState({
          loader: false,
          // cardDetailsId: filteredCards[0].cardDetailsId,
          selectedCard: filteredCards[0],
          filteredCards: filteredCards
        }, () => {

        })
      }
    } catch (e) {

    }

  }


  render() {
    const { cardPreferanceState, cardState } = this.props
    const { filteredCards, selectedCard, cardDetailsId, } = this.state
    console.log("cardState" , this.props.cardState)
    return (

      <div className="col-md-12 " style={{}}>
        <div className="header-style" style={{}}>
          <h4 className='logmainheading mainheading'>
            Card Restrictions
          </h4>
          <p>Set preferred locks. Select and customise the locks you wish to place on your card.</p>
          <p>Choose what type of transactions you want to block on your prepaid card. <br />
            <span> If you change your mind, you will need to unlock the transaction type to avoid declined transactions.</span></p>

        </div>
        {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?
          <div className="row">
            <div className="col-md-12 nopadding ">

              <div className="col-md-12 ">
                <div className="row">
                  {/* <div className="col-md-3" style={{ marginTop: "8px" }}>
                    <span style={{ fontSize: "16px", fontWeight: "bold", color: "#585555" }}>
                      {selectedCard.cardProgramId}
                    </span>
                  </div> */}
                  <div className=" col-sm-12">
                    <div className="row">

                      <div className="offset-sm-8 col-sm-4">
                        <div className="row">
                          {/* <div className="col-md-3 text-left pt-2" >
                            <label style={{ fontWeight: "bold", fontSize: "16px", color: "#585555" }}>Select Card </label>
                          </div> */}
                          <div className="col-sm-12" >
                            <SelectField
                              floatingLabelText=""
                              onChange={this.handleSelect1}
                              className="input-width"
                              name="Selected Card"
                              autoComplete='none'
                              style={{ marginTop: -12 }}
                              value={cardDetailsId}>

                              {filteredCards.map((value, i) =>
                                <MenuItem className="menuitem" value={filteredCards[i].cardDetailsId} primaryText={filteredCards[i].cardNumber} key={i} />
                              )}

                            </SelectField>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 nopadding" style={{ padding: "0px 15px" }}>


            </div>
            <div className="col-md-12 nopadding">
              {(this.state.loader ? <div ><LoaderSmall /></div> :
                cardPreferanceState && cardPreferanceState.body ?

                  <div className="col-sm-12 " >

                    <div className="card p-3" style={{ marginBottom: "15px" }}>
                      <div className="row">
                        <div className="col-md-12" style={{ padding: "0px 15px" }}>
                          <div className="summary-header">
                            <div className="row">
                              <div className="col-md-8">
                                <p>Domestic in store transactions</p>
                                <p style={{ fontSize: "12px", }}>This will block all in store purchases made anywhere in {localStorage.getItem('pform')=== 'AU' ? 'Australia' : 'New Zealand'}</p>
                              </div>
                              <div className="col-sm-1" id={"loaderdiv"} style={{ marginTop: "0px" }}  >
                              </div>
                              <div className="col-md-1 text-left tilepadding" style={{ margin: "auto" }}>
                                <ToggleButton
                                  inactiveLabel={''}
                                  activeLabel={''}
                                  colors={{
                                    activeThumb: {
                                      base: 'rgb(237, 143, 64)',  
                                      //81,197,242
                                      // width: '25px',
                                      // height: '25px',
                                    },
                                    inactiveThumb: {
                                      base: 'rgb(192,192,192)',
                                    },
                                    active: {
                                      base: 'rgb(237, 143, 64)',
                                      hover: 'rgb(237, 143, 64)',
                                    },
                                    inactive: {
                                      base: 'rgb(248,248,248)',
                                      hover: 'rgb(235 235 235)',
                                    }
                                  }}
                                  value={!cardPreferanceState.body.pos}
                                  thumbIcon={cardPreferanceState.body.pos === false ? <Heart /> : <Inactive />}
                                  containerStyle={{ display: 'inline-block', width: '50px' }}
                                  // activeThumbStyle={{}}
                                  // inactiveThumbStyle={{border:"3px solid #fff"}}
                                  trackStyle={{ width: '75px', height: "30px", boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 0px 1px" }}
                                  activeThumbStyle={{ border: "3px solid #fff", }}
                                  thumbStyle={{ width: '30px', height: "30px", position: "relative", marginLeft: "5px", border: "3px solid #fff" }}
                                  // thumbAnimateRange={[1, 80]}
                                  // activeLabelStyle={{ width: '50px' }}
                                  // inactiveLabelStyle={{ width: '50px' }}
                                  onToggle={(e) => { this.handleToggle(cardPreferanceState.body) }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card p-3" style={{ marginBottom: "15px" }}>
                      <div className="row">
                        <div className="col-md-12" style={{ padding: "0px 15px" }}>
                          <div className="summary-header">
                            <div className="row">
                              <div className="col-md-8">
                                <p>Domestic online transactions</p>
                                <p style={{ fontSize: "12px", }}>This will block all payments made over the phone or online purchases made in {localStorage.getItem('pform')=== 'AU' ? 'AUD  on .com.au' : 'NZD  on .co.nz'}  websites</p>
                              </div>
                              <div className="col-sm-1" id={"loaderdiv"} style={{ marginTop: "0px" }}  >
                              </div>
                              <div className="col-md-1 text-left tilepadding" style={{ margin: "auto" }}>
                                <ToggleButton
                                  value={!cardPreferanceState.body.ecom}
                                  inactiveLabel={''}
                                  activeLabel={''}
                                  colors={{
                                    activeThumb: {
                                      base: 'rgb(237, 143, 64)',
                                      // width: '25px',
                                      // height: '25px',
                                    },
                                    inactiveThumb: {
                                      base: 'rgb(192,192,192)',
                                    },
                                    active: {
                                      base: 'rgb(237, 143, 64)',
                                      hover: 'rgb(237, 143, 64)',
                                    },
                                    inactive: {
                                      base: 'rgb(248,248,248)',
                                      hover: 'rgb(235 235 235)',
                                    }
                                  }}
                                  thumbIcon={cardPreferanceState.body.ecom === false ? <Heart /> : <Inactive />}
                                  containerStyle={{ display: 'inline-block', width: '50px' }}
                                  trackStyle={{ width: '75px', height: "30px", boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 0px 1px" }}
                                  activeThumbStyle={{ border: "3px solid #fff", }}
                                  thumbStyle={{ width: '30px', height: "30px", position: "relative", marginLeft: "5px", border: "3px solid #fff" }}
                                  onToggle={(e) => { this.handleToggleEcom(cardPreferanceState.body) }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card p-3" style={{ marginBottom: "15px" }}>
                      <div className="row">
                        <div className="col-md-12" style={{ padding: "0px 15px" }}>
                          <div className="summary-header">
                            <div className="row">
                              <div className="col-md-8">
                                <p>International in store and online transactions</p>
                                <p style={{ fontSize: "12px", }}>This will block all purchases made on international websites using foreign currency or when your card number is given over the phone for purchases in foreign currencies </p>
                              </div>
                              <div className="col-sm-1" id={"loaderdiv"} style={{ marginTop: "0px" }}  >

                              </div>
                              <div className="col-md-1 text-left tilepadding" style={{ margin: "auto" }}>
                                <ToggleButton
                                  value={!cardPreferanceState.body.international}
                                  inactiveLabel={''}
                                  activeLabel={''}
                                  colors={{
                                    activeThumb: {
                                      base: 'rgb(237, 143, 64)',
                                      // width: '25px',
                                      // height: '25px',
                                    },
                                    inactiveThumb: {
                                      base: 'rgb(192,192,192)',
                                    },
                                    active: {
                                      base: 'rgb(237, 143, 64)',
                                      hover: 'rgb(237, 143, 64)',
                                    },
                                    inactive: {
                                      base: 'rgb(248,248,248)',
                                      hover: 'rgb(235 235 235)',
                                    }
                                  }}
                                  thumbIcon={cardPreferanceState.body.international === false ? <Heart /> : <Inactive />}
                                  containerStyle={{ display: 'inline-block', width: '50px' }}
                                  trackStyle={{ width: '75px', height: "30px", boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 0px 1px" }}
                                  activeThumbStyle={{ border: "3px solid #fff", }}
                                  thumbStyle={{ width: '30px', height: "30px", position: "relative", marginLeft: "5px", border: "3px solid #fff" }}
                                  onToggle={(e) => { this.handleToggleOverseas(cardPreferanceState.body) }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    {(this.state.tapAndPay === true &&
                      <div className="card p-3" style={{ marginBottom: "15px" }}>
                        <div className="row">
                          {(this.state.tapAndPay === true &&

                            <div className="col-md-12" style={{ padding: "0px 15px" }}>
                              <div className="summary-header">
                                <div className="row">
                                  <div className="col-md-8">
                                    <p>Tap and Pay transactions</p>
                                    <p style={{ fontSize: "12px", }}>This will block all purchases made using Paywave Meaning you will need to insert your card and enter your PIN for all transactions </p>
                                  </div>
                                  <div className="col-sm-1" id={"loaderdiv"} style={{ marginTop: "0px" }}  >
                                  </div>
                                  <div className="col-md-1 text-left tilepadding" style={{ margin: "auto" }}>
                                    <ToggleButton
                                      value={!cardPreferanceState.body.contactless}
                                      inactiveLabel={''}
                                      activeLabel={''}
                                      colors={{
                                        activeThumb: {
                                          base: 'rgb(237, 143, 64)',
                                          // width: '25px',
                                          // height: '25px',
                                        },
                                        inactiveThumb: {
                                          base: 'rgb(192,192,192)',
                                        },
                                        active: {
                                          base: 'rgb(237, 143, 64)',
                                          hover: 'rgb(237, 143, 64)',
                                        },
                                        inactive: {
                                          base: 'rgb(248,248,248)',
                                          hover: 'rgb(235 235 235)',
                                        }
                                      }}
                                      thumbIcon={cardPreferanceState.body.contactless === false ? <Heart /> : <Inactive />}
                                      containerStyle={{ display: 'inline-block', width: '50px' }}
                                      trackStyle={{ width: '75px', height: "30px", boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 0px 1px" }}
                                      activeThumbStyle={{ border: "3px solid #fff", }}
                                      thumbStyle={{ width: '30px', height: "30px", position: "relative", marginLeft: "5px", border: "3px solid #fff" }}
                                      onToggle={(e) => { this.handleToggleTap(cardPreferanceState.body) }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>)}
                    {(this.state.atmAccess === true &&

                      <div className="card p-3" style={{ marginBottom: "15px" }}>
                        <div className="row">
                          {(this.state.atmAccess === true &&
                            <div className="col-md-12 mt-4" style={{ padding: "0px 15px" }}>
                              <div className="summary-header">
                                <div className="row">
                                  <div className="col-md-8 ">
                                    <p> ATM Withdrawals </p>
                                    <p style={{ fontSize: "12px", }}>This will block any ATM withdrawals, domestic or international</p>
                                  </div>
                                  <div className="col-sm-1" id={"loaderdiv"} style={{ marginTop: "0px" }}  >

                                  </div>
                                  <div className="col-md-1 text-left tilepadding" style={{ margin: "auto" }}>
                                    <ToggleButton
                                      value={!cardPreferanceState.body.atm}
                                      inactiveLabel={''}
                                      activeLabel={''}
                                      colors={{
                                        activeThumb: {
                                          base: 'rgb(237, 143, 64)',
                                          // width: '25px',
                                          // height: '25px',
                                        },
                                        inactiveThumb: {
                                          base: 'rgb(192,192,192)',
                                        },
                                        active: {
                                          base: 'rgb(237, 143, 64)',
                                          hover: 'rgb(237, 143, 64)',
                                        },
                                        inactive: {
                                          base: 'rgb(248,248,248)',
                                          hover: 'rgb(235 235 235)',
                                        }
                                      }}
                                                                     thumbIcon={cardPreferanceState.body.atm === false ? <Heart /> : <Inactive />}
                                      containerStyle={{ display: 'inline-block', width: '50px' }}
                                      trackStyle={{ width: '75px', height: "30px", boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 0px 1px" }}
                                      activeThumbStyle={{ border: "3px solid #fff", }}
                                      thumbStyle={{ width: '30px', height: "30px", position: "relative", marginLeft: "5px", border: "3px solid #fff" }}
                                      onToggle={(e) => { this.handleToggleATM(cardPreferanceState.body) }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                    )}
                  </div>
                  :
                  <div> </div>)}
            </div>
          </div>

          : <div style={{ marginTop: "200px" }}><LoaderSmall /></div>
        }
      </div>

    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardPreferance);






// WEBPACK FOOTER //
// ./src/components/myprofile/cardpreferance.jsx